import React from 'react';
// simple footer component shows copyright across all pages
const Footer = () => {
  return (
    <footer className="font-sans text-center px-4 py-2 bg-blue-600 text-white text-sm sm:text-base">
      <p>&copy; 2025 ERMiC. All rights reserved.</p>
    </footer>
  );
};

export default Footer;